export function StatusBadge({ value }: { value: string }) {
  const normalized = normalizeStatusClass(value);
  return <span className={`status-badge status-neutral status-${normalized}`}>{value}</span>;
}

function normalizeStatusClass(value: string): string {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return normalized || 'unknown';
}
